export default __webpack_public_path__ + "static/simple-pie-f5f7a1d9c0ff0a7d878c7483fe334857.png";